import {
  Box,
  Center,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Grid,
  Image,
  SkeletonText,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import NavCard from "../../../components/navcard";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { color } from "../../../utils/theme";
import { AppDispatch } from "../../../redux/store";
import { fetchPackages } from "../../../redux/action";
import { RootState } from "../../../redux/reducer/rootReducer";
const Packages = () => {
  const dispatch: AppDispatch = useDispatch();
  const [openPackageDetail, setOpenIndicatorDetail] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const packages = useSelector((state: RootState) =>
    state.packages.data.filter(
      (item) => item.name !== null && item.type === "Control"
    )
  );

  const navigate = useNavigate();
  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      dispatch(fetchPackages());
      setIsLoading(false);
    }, 2000);
  }, [dispatch]);

  return (
    <Center>
      <Drawer
        size={"md"}
        isOpen={openPackageDetail}
        placement="right"
        onClose={() => setOpenIndicatorDetail(false)}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader w={"90%"} style={{ textAlign: "left", fontSize: 18 }}>
            {selectedPackage}
          </DrawerHeader>

          <DrawerBody>
            <Text>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ratione
              dignissimos, saepe labore dolorum, ipsam vitae esse rerum
              laudantium perferendis ullam impedit quidem facere quae explicabo.
              Inventore ea deleniti in eius!
            </Text>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Drawer
        size={"md"}
        isOpen={openPackageDetail}
        placement="right"
        onClose={() => setOpenIndicatorDetail(false)}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader w={"90%"} style={{ textAlign: "left", fontSize: 18 }}>
            {selectedPackage}
          </DrawerHeader>

          <DrawerBody>
            <Text>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ratione
              dignissimos, saepe labore dolorum, ipsam vitae esse rerum
              laudantium perferendis ullam impedit quidem facere quae explicabo.
              Inventore ea deleniti in eius!
            </Text>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Box
        display={"flex"}
        h={"90%"}
        flexDirection={"column"}
        justifyContent={"flex-start"}
        alignSelf={"flex-start"}
        alignContent={"flex-start"}
        alignItems={"flex-start"}
        textAlign={"left"}
        mt={5}
      >
        <Text
          fontSize={[18, 18, 18, 16, 24, 26]}
          textAlign={"left"}
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"left"}
          alignContent={"center"}
          cursor={"pointer"}
          onClick={() => {
            navigate("/");
          }}
          fontWeight={"normal"}
          color={color.primary}
          gap={5}
          alignItems={"center"}
          my={7}
        >
          <Image
            _hover={{ shadow: "md" }}
            src={require("../../../assets/left-arrow.png")}
            w={"30px"}
            h={"30px"}
          />
          Quality Control Indicator Packages
        </Text>
        <Grid
          templateColumns={[
            "repeat(1, 1fr)",
            "repeat(2, 1fr)",
            "repeat(3, 1fr)",
            "repeat(4, 1fr)",
          ]}
          gap={[4, 4, 5, 5, 5, 10]}
        >
          {isLoading ? (
            <>
              {Array.from({ length: 10 }).map((_, index) => (
                <Box
                  sx={{
                    h: 200,
                  }}
                  w={[300, 300, 300, 300, 300, 350]}
                  key={index}
                  padding="6"
                  boxShadow="lg"
                  bg="white"
                >
                  <SkeletonText
                    mt="4"
                    noOfLines={5}
                    spacing="4"
                    skeletonHeight="2"
                  />
                </Box>
              ))}
            </>
          ) : (
            <>
              {packages.map((item) => (
                <NavCard
                  showInfo={true}
                  showIcon={false}
                  icon={"box"}
                  title={item.name}
                  onClick={() => {
                    navigate(`indicator-packages/${item.name}/${item.id}`);
                  }}
                  onInfoClick={() => {
                    setOpenIndicatorDetail(true);
                    setSelectedPackage(item.name);
                  }}
                />
              ))}
            </>
          )}
        </Grid>
      </Box>
    </Center>
  );
};

export default Packages;
